module.exports = __webpack_public_path__ + "img/6g.6834dfb2.svg";